<template>
    <span>
        <!--el-tag size="medium"
                :key="addr"
                v-for="addr in address_list"
                closable
                :disable-transitions="false"
                @close="handleRemove(addr)">
            {{addr.toLowerCase()}}
        </el-tag-->
        <span v-for="addr in address_list" :key="addr" class="badge badge-info badge-pill mr-1">
            {{addr.toLowerCase()}}<span class="el-icon-error pl-1" style="cursor: pointer" @click="handleRemove(addr)"></span>
        </span>

        <el-autocomplete
            size="mini"
            class="inline-input"
            v-model="inputValue"
            :fetch-suggestions="querySearch"
            placeholder="请输入邮箱地址并回车"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleLostFocus"
            @select="handleSelect">
        </el-autocomplete>
    </span>
</template>

<script>
  import {isValidEmail} from '@/utils/validate'

  export default {
    name: 'EmailAddress',
    props: {
      addressList: {
        type: Array,
        required: true
      },
      buttonText: {
        type: String
      }
    },
    data() {
      return {
        default_address_list: [],
        address_list: [],
        suggest_list: [],
        inputVisible: false,
        inputValue: ''
      }
    },
    methods: {
      handleRemove(address) {
        this.address_list.splice(this.address_list.indexOf(address), 1);
        if (this.default_address_list.indexOf(address) !== -1) {
          this.suggest_list.push({value: address});
        }
        this.$emit('update:addressList', this.address_list);
        this.$emit('updateList', this.address_list);
      },
      querySearch(queryString, cb) {
        let results;
        let suggest_list = this.suggest_list;
        if (suggest_list) {
          results = queryString ? (suggest_list.filter(this.createFilter(queryString))) : suggest_list;
        } else {
          results = suggest_list;
        }

        cb(results);
      },
      createFilter(queryString) {
        return (item) => {
          return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        if (this.handleInputConfirm()) {
          this.suggest_list.splice(this.suggest_list.indexOf(item), 1);
        }
      },
      handleInputConfirm() {
        let inputValue = this.inputValue
        if (!isValidEmail(inputValue)) {
          this.$message.error("邮件地址格式不正确");
          return false;
        }
        if (this.address_list.indexOf(inputValue) !== -1) {
          this.$message.error("邮件地址已经添加");
          return false;
        }

        this.address_list.push(inputValue);
        // this.inputVisible = false;
        this.inputValue = '';

        this.$emit('update:addressList', this.address_list);

        return true;
      },
      handleLostFocus() {
        this.inputVisible = false;
        this.inputValue = '';
      }

    },
    created() {
      this.default_address_list = Object.assign([], this.addressList);
      this.address_list = Object.assign([], this.addressList);
      this.suggest_list = [];
    }
  }
</script>

<style scoped>
</style>
